/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Full_Mock_2Inputs */

const en_cap_full_mock_2 = /** @type {(inputs: Cap_Full_Mock_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents`)
};

const lv_cap_full_mock_2 = /** @type {(inputs: Cap_Full_Mock_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aģenti`)
};

/**
* | output |
* | --- |
* | "Agents" |
*
* @param {Cap_Full_Mock_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_full_mock_2 = /** @type {((inputs?: Cap_Full_Mock_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Full_Mock_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_full_mock_2(inputs)
	return en_cap_full_mock_2(inputs)
});